import React, { useState } from 'react';
import { useWorkflow } from '../contexts/WorkflowContext';
import './Modal.css';

const WorkflowModal = ({ onClose }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const { createWorkflow } = useWorkflow();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!name.trim()) {
      alert('Please enter a workflow name');
      return;
    }

    try {
      await createWorkflow(name.trim(), description.trim());
      handleClose();
    } catch (error) {
      alert('Failed to create workflow: ' + error.message);
    }
  };

  const handleClose = () => {
    setName('');
    setDescription('');
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Create New Workflow</h3>
          <button className="close-btn" onClick={handleClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="workflowName">Workflow Name:</label>
              <input
                type="text"
                id="workflowName"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter workflow name"
                required
                autoFocus
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="workflowDescription">Description:</label>
              <textarea
                id="workflowDescription"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter workflow description (optional)"
                rows="3"
              />
            </div>
          </div>
          
          <div className="modal-footer">
            <button type="button" className="btn" onClick={handleClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Create Workflow
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default WorkflowModal;
